module.exports = __webpack_public_path__ + "img/designS.3c5e15cc.png";